import { RutPipe } from 'ng2-rut';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArchivosConErrorPipe } from './archivosConError.pipe';
import {
  ComunaFilterPipe,
  DiaFilterPipe,
  EmpresaFilterPipe,
  ProcesoFilterPipe
} from './selectFilter.pipe';
import { FormatFechaDesplieguePipe } from './formatFecha';

@NgModule({
  declarations: [
    ArchivosConErrorPipe,
    ComunaFilterPipe,
    DiaFilterPipe,
    EmpresaFilterPipe,
    ProcesoFilterPipe,
    FormatFechaDesplieguePipe
  ],
  imports: [CommonModule],
  exports: [
    ArchivosConErrorPipe,
    ComunaFilterPipe,
    DiaFilterPipe,
    EmpresaFilterPipe,
    ProcesoFilterPipe,
    FormatFechaDesplieguePipe
  ]
})
export class PipesModule {}
